import { USED_FONTS } from '@/constants/Fonts';
import { useCustomerStore } from '@/stores/useCustomerStore';
import { de } from 'date-fns/locale';
import { setDefaultOptions } from 'date-fns/setDefaultOptions';
import { useFonts } from 'expo-font';
import i18n from "i18next";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { initReactI18next } from "react-i18next";
import { Platform } from 'react-native';
import { useShallow } from 'zustand/react/shallow';

const DEFAULT_LANG = 'de';

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: require('@/i18n/en.json') },
        de: { translation: require('@/i18n/de.json') }
    },
    fallbackLng: DEFAULT_LANG,
    interpolation: { escapeValue: false },
    saveMissing: true,
});

export const useInitialize = () => {
    const [state, setState] = useState('idle');

    const [fontsLoaded] = useFonts(Platform.OS === 'web' ? {} : USED_FONTS);

    const { ensureUniqueId, country } = useCustomerStore(useShallow(s => ({
        ensureUniqueId: s.ensureUniqueId,
        country: s.country,
    })));

    const initLocale = useCallback(async () => {
        await i18n.changeLanguage(country?.storeCode ?? DEFAULT_LANG);
        setDefaultOptions({ locale: de });
    }, [country?.storeCode]);

    useEffect(() => {
        if (!fontsLoaded) return;

        const initialize = async () => {
            await Promise.all([
                initLocale(),
            ]);
            ensureUniqueId();
            setState('ready');
        };

        initialize();
    }, [fontsLoaded, initLocale, ensureUniqueId]);

    return useMemo(() => ({ state }), [state]);
};